import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getBulkUpdateItemsModel = createSelector(
    getModel,
    (model) => model.bulkUpdateItems,
);

export const getIsFetchingBulk = createSelector(
    getBulkUpdateItemsModel,
    (model) => model.isFetching,
);

/* Fetch productos */
export const getProductsModel = createSelector(
    getModel,
    (model) => model.products,
);

export const getProductsData = createSelector(
    getProductsModel,
    (model) => model.data.data || [],
);

export const getProductsErrors = createSelector(
    getProductsModel,
    (model) => model.errors,
);

export const getProductsIsFetching = createSelector(
    getProductsModel,
    (model) => model.isFetching,
);

export const getProductsPagination = createSelector(
    getProductsModel,
    (model) => model.data.pagination || {},
);
